import { formatDate } from '../utils/formatDate.js';
import { formatPhone } from '../utils/formatPhone.js';
export function LeadServiceAPI() {
    async function send(body, isIndividualType = false) {
        const { typeForm, region, phone = '', email, birthday, desiredMeetingDate, inn, addressBranch, secondaryPhone = '', bankEmpolee, applicationDate, serviceDirection, ...staticBody } = body;
        const isNaturalPerson = isIndividualType && serviceDirection !== 'Юридическое лицо / ИП';
        const url = isNaturalPerson ? '/api/v1/lead' : '/api/v1/sendcorporatelead';
        const submitBody = {
            typeForm,
            ...getRegion(region, isNaturalPerson),
            ...getEmail(email, isNaturalPerson),
            ...getPhone(phone),
            ...getFormatDate(desiredMeetingDate, 'desiredMeetingDate'),
            ...(isNaturalPerson ? getFormatDate(birthday) : { inn }),
            ...(typeForm === 'FEEDBACK'
                ? {}
                : {
                    addressBranch,
                    bankEmpolee,
                    applicationDate,
                    ...getSecondaryPhone(secondaryPhone),
                }),
            ...staticBody,
        };
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                mode: 'cors',
                body: JSON.stringify(submitBody),
            });
            if (!response?.ok) {
                return null;
            }
            const data = await response.json();
            return data;
        }
        catch (e) {
            return null;
        }
    }
    return {
        send,
    };
}
const getPhone = (phone) => (phone ? { phone: formatPhone(phone) } : {});
const getFormatDate = (date, key = 'birthday') => date ? { [key]: formatDate(date) } : {};
const getRegion = (region, isNaturalPerson = true) => ({
    [isNaturalPerson ? 'regionBranch' : 'region']: region,
});
const getEmail = (email, isNaturalPerson = true) => ({
    [isNaturalPerson ? 'email' : 'mail']: email,
});
const getSecondaryPhone = (secondaryPhone = '') => {
    return !secondaryPhone || secondaryPhone === '+7 ('
        ? {}
        : { secondaryPhoneNumber: formatPhone(secondaryPhone) };
};
//# sourceMappingURL=LeadServiceAPI.js.map